<template>
    <div>
        <div class="top-box">
            <img class="bg" src="@/assets/share/friendDesc/bg.png">
                <div class="banner">
                    <van-row>
                        <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png">
                        </van-col>
                        <van-col span="12">
                        </van-col>
                        <van-col span="6" v-show="isFriend">
                            <img @click="getPrivilege" class="set-icon" src="@/assets/share/friendDesc/set.png">
                        </van-col>
                    </van-row>
                </div>
            <img class="user-icon" :src="user.userAvatar ? user.userAvatar : defaultImg">
            <div class="user-name-remark">
                <div>{{user.userNameRemark ? user.userNameRemark : user.userName}}</div>
            </div>
            <div class="user-info-btn">
                <div class="uuser-info-text" @click="toPersonal">个人资料</div>
            </div>
        </div>
        <div class="target-box">
            <div class="step-item">
                <div class="target-type">今日步数</div>
                <div class="target-value"><span class="step-current">{{user.step}}/</span><span class="target-num">{{user.userTargetStep}}<span
                        class="unit">步</span></span></div>
            </div>
            <div class="cal-item">
                <div class="target-type-cal">运动能耗</div>
                <div class="target-value"><span class="cal-current">{{user.calorie}}/</span><span class="target-num">{{user.userTargetCalorie}}<span
                        class="unit">千卡</span></span></div>
            </div>
            <div class="step-pro-box">
                <canvas id="myCanvas"></canvas>
                <canvas id="myCanvas2"></canvas>
            </div>
        </div>
        <div class="health-box" v-show="bodyStatus">
            <div class="privilege-title">健康数据</div>
            <div class="health-item" @click="toCondition">
                <div class="health-item-text">身体状态</div>
                <img class="to-icon" src="@/assets/share/friendDesc/to.png">
            </div>
        </div>
        <div class="health-box sport-box" v-if="sportDataStatus">
            <div class="privilege-title">运动记录</div>
            <div class="to-all" @click="toAll(0)" v-if="sportItem">全部 <img class="to-all-icon" src="@/assets/share/friendDesc/toAll.png"></div>
            <div class="d-item" v-if="sportItem">
                <div class="d-top">
                    <img class="d-avatar"
                         :src="sportItem.userAvatar ? sportItem.userAvatar : defaultImg">
                    <div class="d-info">
                        <div class="d-username">{{user.userNameRemark ? user.userNameRemark : user.userName}}</div>
                        <div class="d-time">{{sportItem.createTime}}</div>
                    </div>
                </div>
                <div class="d-sport" v-if="sportItem.sportId" @click="openDynamicDesc(sportItem)">
                    <div class="icon-box">
                        <gps-baidu :gps-data="sportItem.gpsData" :canvas-id="sportItem.sportId" :sport-type="sportItem.sportType"></gps-baidu>
                    </div>
                    <div class="s-info" v-if="!checkPower(sportItem.sportType)">
                        <div class="s-num-box"><span
                                class="s-num">{{(sportItem.distance / 100000).toFixed(2)}}</span><span
                                class="s-num-unit">公里</span></div>
                        <div class="s-sub">
                            <img class="s-sub-icon" src="@/assets/share/home/map.png">
                            <span v-if="!(sportItem.city&&sportItem.district)">暂无地址信息</span>
                            <span v-if="sportItem.city||sportItem.district">{{sportItem.cite}}{{sportItem.district}}</span>
                        </div>
                    </div>
                    <div class="s-info" v-if="checkPower(sportItem.sportType)">
                        <div class="s-num-box"><span class="s-num">{{sportItem.powerGroupNum}}</span><span
                                class="s-num-unit">组</span></div>
                        <div class="s-sub">力量训练</div>
                    </div>
                    <div class="s-type"
                         :style="{'background-image':`url(${require(`@/assets/share/home/${sportItem.sportType}.png`)}`}">
                        <div class="s-type-text">"{{sportItem.sportType}}"</div>
                    </div>
                    <van-row>
                        <van-col span="8" v-if="sportItem.sportType.indexOf('游泳') == -1">
                            <div class="d-desc-item">
                                <div class="desc-num">{{sportItem.avgHeartrate}}</div>
                                <div class="desc-title">平均心率</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="sportItem.sportType.indexOf('游泳') != -1">
                            <div class="d-desc-item">
                                <div class="desc-num">{{dealSwolf(sportItem)}}</div>
                                <div class="desc-title">平均SWOLF</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="checkPower(sportItem.sportType)">
                            <div class="d-desc-item d-desc-center">
                                <div class="desc-num">{{parseInt(sportItem.calories/1000)}}</div>
                                <div class="desc-title">卡路里</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="!checkPower(sportItem.sportType)">
                            <div class="d-desc-item d-desc-center">
                                <div class="desc-num">{{dealPach(sportItem)}}</div>
                                <div class="desc-title">{{sportItem.sportType.indexOf('游泳') != -1 ? '百米泳速' : '平均配速'}}
                                </div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="d-desc-item">
                                <div class="desc-num">{{dealTime(sportItem.actTime)}}</div>
                                <div class="desc-title">运动时长</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-bottom">
                    <van-row>
                        <van-col span="12">
                            <div class="d-b-item d-b-item-left">
                                <img v-if="sportItem.isLike" class="d-b-icon" src="@/assets/share/home/like.png"
                                     @click="like(sportItem, 0)">
                                <img v-if="!sportItem.isLike" class="d-b-icon" src="@/assets/share/home/unlike.png"
                                     @click="like(sportItem, 1)">
                                <span class="like-num">{{sportItem.likeNum}}</span>
                            </div>
                        </van-col>
                        <van-col span="12" @click="clickComment(sportItem, 0, sportItem)">
                            <div class="d-b-item">
                                <img class="d-b-icon" src="@/assets/share/home/comment.png">
                                <span class="comment-num">{{sportItem.commentList.length > 0 ? sportItem.commentList.length : '评论'}}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-comment" v-if="sportItem.commentList.length > 0">
                    <div class="d-comment-box">
                        <div class="d-comment-item"
                             @click="clickComment(sportItem, 1, c)"
                             v-for="(c, index) in sportItem.commentList">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span class="comment-username">{{c.userNameRemark ? c.userNameRemark : c.userName}}</span></span>
                            <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{c.toUserNameRemark ? c.toUserNameRemark : c.toUserName}}：</span>
                            </span>
                            <span v-if="c.type == 0" class="comment-username">:</span>
                            {{c.content}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-item" v-if="!sportItem">
                <div class="no-prop">
                    TA今年还没有运动记录
                </div>
            </div>
        </div>
        <div class="health-box sport-box" v-if="ecgDataStatus">
            <div class="privilege-title">心电数据</div>
            <div class="to-all" @click="toAll(1)" v-if="ecgItem">全部 <img class="to-all-icon" src="@/assets/share/friendDesc/toAll.png"></div>
            <div class="d-item" v-if="ecgItem">
                <div class="d-top">
                    <img class="d-avatar"
                         :src="ecgItem.userAvatar ? ecgItem.userAvatar : defaultImg">
                    <div class="d-info">
                        <div class="d-username">{{user.userNameRemark ? user.userNameRemark : user.userName}}</div>
                        <div class="d-time">{{ecgItem.createTime}}</div>
                    </div>
                </div>
                <div class="d-ecg" v-if="ecgItem.ecgId" @click="openDynamicDesc(ecgItem)">
                    <van-row>
                        <van-col span="14">
                            <div class="d-ecg-left">
                                <div class="ecg-info">
                                    <div v-if="!ecgItem.isError" class="ecg-normal"></div>
                                    <div v-if="ecgItem.isError" class="ecg-error"></div>
                                    <div class="ecg-conclusion">{{ecgItem.conclusion}}</div>
                                </div>
                                <div class="ecg-from">由<span class="ecg-add">{{ecgItem.deviceName}}</span>采集</div>
                            </div>
                        </van-col>
                        <div class="ecg-chart" :id="ecgItem.ecgId"></div>
                    </van-row>
                </div>
                <div class="d-bottom">
                    <van-row>
                        <van-col span="12">
                            <div class="d-b-item d-b-item-left">
                                <img v-if="ecgItem.isLike" class="d-b-icon" src="@/assets/share/home/like.png"
                                     @click="like(ecgItem, 0)">
                                <img v-if="!ecgItem.isLike" class="d-b-icon" src="@/assets/share/home/unlike.png"
                                     @click="like(ecgItem, 1)">
                                <span class="like-num">{{ecgItem.likeNum}}</span>
                            </div>
                        </van-col>
                        <van-col span="12" @click="clickComment(ecgItem, 0, ecgItem)">
                            <div class="d-b-item">
                                <img class="d-b-icon" src="@/assets/share/home/comment.png">
                                <span class="comment-num">{{ecgItem.commentList.length > 0 ? ecgItem.commentList.length : '评论'}}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-comment" v-if="ecgItem.commentList.length > 0">
                    <div class="d-comment-box">
                        <div class="d-comment-item"
                             @click="clickComment(ecgItem, 1, c)"
                             v-for="(c, index) in ecgItem.commentList">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span class="comment-username">{{c.userNameRemark ? c.userNameRemark : c.userName}}</span></span>
                            <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{c.toUserNameRemark ? c.toUserNameRemark : c.toUserName}}：</span>
                            </span>
                            <span v-if="c.type == 0" class="comment-username">:</span>
                            {{c.content}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-item" v-if="!ecgItem">
                <div class="no-prop">
                    TA还没有心电数据
                </div>
            </div>
        </div>
        <div class="invite" v-show="!isFriend" @click="toConfirm">邀请TA</div>
        <van-popup v-model="showComment" position="bottom" style="background: #000000">
            <div class="apply-value">
                <van-field v-model="commentInfo.content" :placeholder="commentInfo.type == 0 ? '评论':'回复'">
                    <template #button>
                        <van-button size="mini" type="primary" @click="sendComment">发送</van-button>
                    </template>
                </van-field>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getToday} from "../../utils/dateUtils";
    import {Dialog, Toast} from 'vant';
    import {SwitchTime, SwitchTimeToM} from '@/utils/dateUtils';
    import gpsBaidu from "../../components/gpsBaidu";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'friendDesc',
        components: {
            gpsBaidu
        },
        data() {
            return {
                sharerId: localStorage.getItem('sharerId'),
                user: {},
                defaultImg: require('@/assets/share/home/noImg.png'),
                isFriend: 1,
                bodyStatus: 0,
                sportDataStatus: 0,
                ecgDataStatus: 0,
                sportItem: {
                    commentList: []
                },
                ecgItem: {
                    commentList: []
                },
                showComment: false,
                commentInfo: {},
            }
        },
        mounted() {
            this.getFriendInfo();
        },
        methods: {
            back() {
                this.$router.back();
            },
            openDynamicDesc(item) {
                WebJSBridge.call("openDynamicDesc", {
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    startSportTime: item.createTime,
                    userAvatar: item.userAvatar
                }, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            toAll(tag) {
                if (this.user.userNameRemark) {
                    localStorage.setItem('userNameRemark', this.user.userNameRemark);
                }
                localStorage.setItem('allTag', tag);
                localStorage.setItem('allSharerId', this.user.userId);
                this.$router.push({
                    name: 'allDynamics'
                })
            },
            toCondition() {
                this.$router.push({
                    name: 'condition'
                })
            },
            toPersonal() {
                this.$router.push({
                    name: 'personal',
                    params: {
                        isFirend: this.isFriend
                    }
                })
            },
            toConfirm() {
                localStorage.setItem("addUser", JSON.stringify(this.user));
                this.$router.push({
                    name: 'confirm',
                    params: {
                        type: 'qr'
                    }
                })
            },
            getFriendInfo() {
                this.$api.share.getFriendsDetail({
                    date: getToday(),
                    sharerId: this.sharerId
                }).then(res => {
                    this.user = res.info.friendData;
                    this.user.userId = this.sharerId;
                    this.isFriend = res.info.status;
                    this.bodyStatus = res.info.bodyStatus;
                    this.sportDataStatus = res.info.sportDataStatus;
                    this.ecgDataStatus = res.info.ecgDataStatus;
                    this.sportItem = res.info.sportData;
                    this.ecgItem = res.info.ecgData;

                    if (this.ecgDataStatus && this.ecgItem && this.ecgItem.ecgId) {
                        this.$nextTick(function () {
                            this.drawEcg(this.ecgItem);
                        })
                    }

                    if (this.user.calorie) {
                        this.user.calorie = Math.round(this.user.calorie / 1000);
                    } else {
                        this.user.calorie = 0;
                    }
                    if (!this.user.step) {
                        this.user.step = 0;
                    }

                    // 计算canvas尺寸
                    let clientWidth = document.documentElement.clientWidth;
                    let ratio = clientWidth / 375;
                    this.drawRing(this.user.step / this.user.userTargetStep * 100, ratio);
                    this.drawRing2(this.user.calorie / this.user.userTargetCalorie * 100, ratio);
                })
            },
            drawRing(val, ratio) {
                //先创建一个canvas画布对象，设置宽高，val%百分比
                var c = document.getElementById('myCanvas');
                var devicePixelRatio = window.devicePixelRatio || 1;
                var ctx = c.getContext('2d');
                ctx.canvas.width = ratio * 100 * devicePixelRatio;
                ctx.canvas.height = ratio * 100 * devicePixelRatio;
                ctx.scale(devicePixelRatio, devicePixelRatio);
                //圆环有两部分组成，底部灰色完整的环，根据百分比变化的环
                //先绘制底部完整的环
                //起始一条路径
                ctx.beginPath();
                //设置当前线条的宽度
                ctx.lineWidth = ratio * 10;//10px
                //设置笔触的颜色
                ctx.strokeStyle = '#1B331F';
                //arc()方法创建弧/曲线（用于创建圆或部分圆）arc(圆心x,圆心y,半径,开始角度,结束角度)
                ctx.arc(ratio * 50, ratio * 50, ratio * 40, 0, 2 * Math.PI);
                //绘制已定义的路径
                ctx.stroke();

                //绘制根据百分比变动的环
                ctx.beginPath();
                ctx.lineWidth = ratio * 10;
                ctx.lineCap = 'round';
                ctx.strokeStyle = '#20D38F';
                ctx.shadowColor = '#00FF9E';
                ctx.shadowBlur = ratio * 5
                //设置开始处为0点钟方向（-90*Math.PI/180）
                //x为百分比值（0-100）
                ctx.arc(ratio * 50, ratio * 50, ratio * 40, -Math.PI / 2, (val * 3.6 - 90) * Math.PI / 180); //从-PI/2转到PI/10
                ctx.stroke();
                ctx.beginPath();

                var circ = Math.PI * 2;
                var quart = Math.PI / 2;
                var current = val / 100;

                var x = 50 + Math.cos(((circ) * current) - quart) * 40;//确定坐标（此处圆心即是原点）
                var y = 50 + Math.sin(((circ) * current) - quart) * 40;//确定坐标（此处圆心即是原点）
                ctx.lineWidth = ratio * 5;
                ctx.arc(ratio * x, ratio * y, 1, 0, 2 * Math.PI, true);
                ctx.fillStyle = '#A5EDD2';
                ctx.fill();
                ctx.strokeStyle = '#A5EDD2';
                ctx.stroke();
            },
            drawRing2(val, ratio) {
                //先创建一个canvas画布对象，设置宽高，val%百分比
                var c = document.getElementById('myCanvas2');
                var devicePixelRatio = window.devicePixelRatio || 1;
                var ctx = c.getContext('2d');
                ctx.canvas.width = ratio * 100 * devicePixelRatio;
                ctx.canvas.height = ratio * 100 * devicePixelRatio;
                ctx.scale(devicePixelRatio, devicePixelRatio);
                //圆环有两部分组成，底部灰色完整的环，根据百分比变化的环
                //先绘制底部完整的环
                //起始一条路径
                ctx.beginPath();
                //设置当前线条的宽度
                ctx.lineWidth = ratio * 10;//10px
                //设置笔触的颜色
                ctx.strokeStyle = '#2D1916';
                //arc()方法创建弧/曲线（用于创建圆或部分圆）arc(圆心x,圆心y,半径,开始角度,结束角度)
                ctx.arc(ratio * 50, ratio * 50, ratio * 20, 0, 2 * Math.PI);
                //绘制已定义的路径
                ctx.stroke();
                ctx.closePath();

                //绘制根据百分比变动的环
                ctx.beginPath();
                ctx.lineWidth = ratio * 10;
                ctx.lineCap = 'round';
                ctx.strokeStyle = '#FF9250';
                ctx.shadowColor = '#FF9250';
                ctx.shadowBlur = ratio * 5
                //设置开始处为0点钟方向（-90*Math.PI/180）
                //x为百分比值（0-100）
                ctx.arc(ratio * 50, ratio * 50, ratio * 20, -Math.PI / 2, (val * 3.6 - 90) * Math.PI / 180); //从-PI/2转到PI/10
                ctx.stroke();
                ctx.closePath();
                ctx.beginPath();

                var circ = Math.PI * 2;
                var quart = Math.PI / 2;
                var current = val / 100;

                var x = 50 + Math.cos(((circ) * current) - quart) * 20;//确定坐标（此处圆心即是原点）
                var y = 50 + Math.sin(((circ) * current) - quart) * 20;//确定坐标（此处圆心即是原点）
                ctx.lineWidth = ratio * 5;
                ctx.arc(ratio * x, ratio * y, 1, 0, 2 * Math.PI, true);
                ctx.fillStyle = '#FFD3B9';
                ctx.fill();
                ctx.strokeStyle = '#FFD3B9';
                ctx.stroke();
            },
            toPrivilege() {
                localStorage.setItem("addUser", JSON.stringify(this.user));
                this.$router.push({
                    name: 'remarkSet',
                    params: {
                        type: 'update'
                    }
                })
            },
            getPrivilege() {
                this.$api.share.selectAuthority({
                    sharerId: this.user.userId
                }).then(res => {
                    localStorage.setItem("statusPrivilege", res.info.statusPrivilege);
                    localStorage.setItem("ecgPrivilege", res.info.ecgPrivilege);
                    localStorage.setItem("sportPrivilege", res.info.sportPrivilege);
                    localStorage.setItem("remark", this.user.userNameRemark);
                    this.toPrivilege();
                })
            },
            toFriendDesc(userId) {
                if (userId != localStorage.getItem("userId")) {
                    localStorage.setItem("sharerId", userId);
                    this.$router.push({
                        name: 'friendDesc'
                    })
                }
            },
            checkPower(sportType) {
                let tag = 0;
                if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                    tag = 1;
                }
                return tag;
            },
            dealTime(n) {
                return SwitchTime(n);
            },
            dealSwolf(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let swolf = item.avgSwolf;
                if (is806) {
                    swolf = parseInt(swolf / 10)
                }
                return swolf;
            },
            dealPach(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let value = item.avgSpeed;
                if (!is806 && (item.sportType != '室内游泳')) {
                    value = value == 0 ? 0 : 10000 / (value ? value : 1);
                }
                if (!is806 && (item.sportType == '室内游泳')) {
                    value = value == 0 ? 0 : 1000 / (value ? value : 1);
                }
                return SwitchTimeToM(value);
            },
            clickComment(item, type, c) {
                this.currentD = item;
                this.commentInfo = {
                    ecgId: item.ecgId,
                    sportType: item.sportType,
                    sportId: item.sportId,
                    startSportTime: item.createTime,
                    type: type,
                    toUserId: c.userId,
                    content: '',
                    userId: localStorage.getItem('userId'),
                    userAvatar: localStorage.getItem('userAvatar').indexOf('http') != -1 ? localStorage.getItem('userAvatar') : '',
                    userName: localStorage.getItem('userName'),
                    toUserName: c.userNameRemark ? c.userNameRemark : c.userName
                }
                this.showComment = true;
            },
            sendComment() {
                this.$api.share.comment(this.commentInfo).then(res => {
                    if (this.commentInfo.ecgId) {
                        this.ecgItem.commentList.push(this.commentInfo);
                        this.$set(this.ecgItem, 'commentList', this.ecgItem.commentList);
                    } else {
                        this.sportItem.commentList.push(this.commentInfo);
                        this.$set(this.sportItem, 'commentList', this.sportItem.commentList);
                    }
                    this.showComment = false;
                    this.commentInfo = {}
                }).catch(e => {
                    Toast('发言不符合社区规范！');
                })
            },
            drawEcg(item) {
                let a = item.ecgFragment;
                let b = a.split(',');
                let c = [];
                for (let i = 0; i < b.length; i++) {
                    c.push(i);
                }
                let myChart = this.$echarts.init(document.getElementById(item.ecgId));
                myChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0,
                        left: 10,
                        right: 10
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: c
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: b,
                            type: 'line',
                            symbol: 'none',
                            color: '#DC3D5C',
                            smooth: false,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            },
            like(item, isLike) {
                this.$api.share.like({
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    startSportTime: item.createTime,
                    isLike,
                    toUserId: item.userId
                }).then(res => {
                    this.$set(item, 'isLike', isLike);
                    if (isLike) {
                        this.$set(item, 'likeNum', item.likeNum + 1);
                    } else {
                        this.$set(item, 'likeNum', item.likeNum - 1);
                    }
                })
            },
        },
    }
</script>

<style scoped>
    .top-box {
        width: 100%;
        height: 178px;
        position: relative;
    }

    .bg {
        width: 100%;
        /*margin-top: -44px;*/
    }

    .banner {
        position: absolute;
        width: 100%;
        top: 0;
        background: transparent;
        border: none;
    }

    .set-icon {
        width: 22px;
        height: 22px;
        margin: 11px 15px 11px 10px;
        float: right;
    }

    .user-icon {
        position: absolute;
        width: 50px;
        height: 50px;
        border: 2px solid rgba(255,255,255,0.69);
        top: 94px;
        left: 36px;
        border-radius: 50%;
    }

    .user-name-remark {
        position: absolute;
        left: 96px;
        top: 111px;
        font-size: 15px;
    }

    .user-name {
        position: absolute;
        left: 96px;
        top: 72px;
        font-size: 15px;
    }

    .user-info-btn {
        border: 1px solid #ffffff;
        border-radius: 4px;
        font-size: 11px;
        position: absolute;
        right: 15px;
        top: 110px;
    }

    .uuser-info-text {
        margin: 3px 4px;
        font-size: 11px;
    }

    .target-box {
        width: 345px;
        height: 142px;
        background: #202020;
        border-radius: 6px;
        margin: -12px auto 0;
        z-index: 111;
        position: relative;
    }

    .step-item {
    }

    .target-type {
        color: #707070;
        font-size: 14px;
        padding-top: 18px;
        padding-left: 23px;
    }

    .target-type-cal {
        color: #707070;
        font-size: 14px;
        padding-top: 10px;
        padding-left: 23px;
    }

    .target-value {
        font-family: SemiBold;
        font-size: 24px;
        padding-left: 23px;
        margin-top: 3px;
    }

    .step-current {
        color: #20D38F;
    }

    .target-num {
        color: #707070;
    }

    .unit {
        font-size: 14px;
        margin-left: 6px;
    }

    .cal-current {
        color: #FF9250;
    }

    .step-pro-box {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 29px;
        top: 24px;
    }

    #myCanvas {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 0px;
        top: 0px;
    }

    #myCanvas2 {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 0px;
        top: 0px;
    }

    .health-box {
        width: 345px;
        margin: 20px auto 0;
    }

    .privilege-title {
        font-size: 17px;
        position: relative;
        padding: 0 10px;
        line-height: 26px;
    }

    .privilege-title::before {
        position: absolute;
        top: 50%;
        left: 0;
        width: 6px;
        height: 17px;
        background-color: #20D38F;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        content: '';
        border-radius: 3px;
    }

    .health-item {
        width: 100%;
        height: 56px;
        background: #202020;
        border-radius: 6px;
        margin-top: 16px;
        position: relative;
    }

    .health-item-text {
        font-size: 14px;
        top: 18px;
        left: 20px;
        position: absolute;
    }

    .to-icon {
        width: 16px;
        position: absolute;
        right: 10px;
        top: 21px;
    }

    .invite {
        width: 359px;
        height: 56px;
        background: #202020;
        border-radius: 14px;
        color: #20D38F;
        font-size: 15px;
        line-height: 56px;
        position: absolute;
        bottom: 20px;
        left: 8px;
        text-align: center;
    }

    .sport-box {
        position: relative;
    }

    .to-all {
        font-size: 14px;
        position: absolute;
        right: 20px;
        top: 3px;
    }

    .to-all-icon {
        width: 16px;
        position: absolute;
        right: -20px;
        top: 1px;
    }

    .dynamics {
        margin: 15px 15px;
    }

    .d-item {
        width: 100%;
        background: #202020;
        margin-bottom: 10px;
        border-radius: 6px;
        padding-bottom: 6px;
        margin-top: 15px;
    }

    .d-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        border: 2px solid rgba(255,255,255,0.69);
        margin: 14px 10px 15px 17px;
        vertical-align: top;
    }

    .d-top {
        border-bottom: 1px solid #000000;
    }

    .d-info {
        display: inline-block;
        margin-top: 14px;
    }

    .d-username {
        opacity: 0.9;
        font-size: 14px;
        line-height: 24px;
    }

    .d-time {
        opacity: 0.6;
        font-size: 12px;
    }

    .icon-box {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        background: #000000;
        border: 1px solid #343434;
        margin: 12px 10px 10px 15px;
        display: inline-block;
        vertical-align: top;
    }

    .s-info {
        display: inline-block;
    }

    .s-num-box {
        margin-top: 3px;
    }

    .s-num-unit {
        opacity: 0.7;
        font-size: 11px;
    }

    .s-num {
        font-family: BlackItalic;
        font-size: 35px;
        opacity: 1;
        letter-spacing: 3px;
        margin-right: 2px;
    }

    .s-sub-icon {
        width: 11px;
        vertical-align: top;
    }

    .s-sub {
        opacity: 0.6;
        margin-top: 5px;
        font-size: 11px;
    }

    .s-type {
        float: right;
        background-size: contain;
        width: 72px;
        height: 72px;
        margin-right: 5px;
    }

    .s-type-text {
        text-align: center;
        opacity: 0.6;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
    }

    .d-sport {
        width: 100%;
    }

    .d-desc-item {
        text-align: center;
        margin-bottom: 16px;
    }

    .d-desc-center {
        /*border-left: 1px solid #FFFFFF;*/
        position: relative;
    }

    .d-desc-center:before {
        content: '';
        position: absolute;
        left: 0;
        top: 35%;
        bottom: auto;
        right: auto;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .d-desc-center:after {
        content: '';
        position: absolute;
        left: auto;
        top: 35%;
        bottom: auto;
        right: 0;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .desc-num {
        font-family: Bold;
        font-size: 24px;
    }

    .desc-title {
        color: #A5A5A5;
        font-size: 11px;
    }

    .d-bottom {
        border-top: 1px solid #000000;
    }

    .d-b-item {
        text-align: center;
        font-size: 11px;
        line-height: 22px;
        margin-top: 6px;
        color: #A5A5A5;
    }

    .d-b-icon {
        width: 22px;
        vertical-align: bottom;
    }

    .d-b-item-left {
        position: relative;
    }

    .d-b-item-left:after {
        content: '';
        position: absolute;
        left: auto;
        top: 13%;
        bottom: auto;
        right: 0;
        height: 70%;
        width: 1px;
        background-color: #000000;
    }

    .ecg-info {
        position: relative;
    }

    .ecg-normal {
        width: 6px;
        height: 6px;
        background: #20d38f;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-error {
        width: 6px;
        height: 6px;
        background: #E24160;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-conclusion {
        display: inline-block;
        font-size: 15px;
        color: #E6E6E6;
        margin-left: 25px;
        margin-top: 10px;
    }

    .ecg-from {
        color: #A5A5A5;
        font-size: 12px;
        margin-left: 15px;
        margin-top: 5px;
    }

    .ecg-add {
        font-weight: bold;
        color: #E6E6E6 !important;
        margin: 0 2px;
    }

    .d-ecg-left {
        margin: 5px 0 15px 0;
    }

    .d-ecg {
        position: relative;
    }

    .ecg-chart {
        position: absolute;
        right: 0;
        top: 0px;
        width: 150px;
        height: 73px;
    }

    .d-comment {
        background: #000000;
        border-radius: 6px;
        margin: 6px 10px 6px 10px;
    }

    .d-comment-box {
        padding: 6px 12px;

    }

    .d-comment-item {
        color: #999999;
        line-height: 26px;
        font-size: 14px;
    }

    .comment-avatar {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        vertical-align: middle;
    }

    .comment-username {
        color: #E6E6E6;
    }

    /deep/ .van-cell {
        background-color: #202020 !important;
        border-radius: 6px;
    }

    /deep/ input {
        background-color: transparent;
        color: #E9E9E9;
        font-size: 14px;
        caret-color: #20D38F;
    }

    /deep/ input::-webkit-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    .no-prop {
        font-size: 14px;
        color: #707070;
        text-align: center;
        padding: 30px 0 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/friendDesc.vue